






































import Avatar from "@/components/NavBar/Avatar.vue";
import {userParsedRoutes} from "@/router/routes.const";
import Vue from "vue";
import {mapMutations} from "vuex";

const Navigation = Vue.extend({
    components: {
        Avatar,
    },
    computed: {
        menuElement() {
            return userParsedRoutes;
        },
    },
    methods: {
        logout() {
            document.cookie = "fcaid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "fccid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "fcpmuc= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "fcuid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";

            this.resetStore();

            this.$notify({
                group: "all",
                title: "Vous êtes déconnecté",
                type: "success",
                duration: 2500,
            });
        },
        ...mapMutations(["resetStore"]),
    },
});

export default Navigation;
